import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history } from '../../_helpers';
import { alertActions, domainActions } from '../../_actions';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import {  userStatus } from '../../_helpers';

import CellLogo from '../../_assets/cell_logo_colored.png';

const optionRenderer = (e) => {
  const handleThis = () => {
    if ( e.validated && e.status === "Active" ) return "active";
    if ( !e.validated && e.status === "Active" ) return "not_validated";
    
    return 'inactive';
  }

  return (
    <div key={e.domain} className={handleThis()}>
      {e.label}
    </div>
  )
}

class SidebarComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      domain_uuid: '',
      sidebarOpen: true,
      domains: [],
      lastClicked: '',
      listed: true,
      selectedDomain: '',
      selected: '',
      clipboardBtn: 'Copiar script',
      clipboardBtnStatus: false,
      domain_root: '',
      gero_id: '',
      status: '',
      allowed: false,
      shouldShowModal: false,
      dataHasBeenLoaded: false,
      userCanAccess: []
    }

    this.follower = React.createRef();
    this.sidebar = React.createRef();
    this.sidebarWrapper = React.createRef();
    this.handleSidebarOpening = this.handleSidebarOpening.bind(this);
    this.handleDomainChange = this.handleDomainChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleUserLogout = this.handleUserLogout.bind(this);
    this.handleClipboard = this.handleClipboard.bind(this);
    this.handleModalDisplay = this.handleModalDisplay.bind(this);
  }

  async componentDidMount() {
    const { dispatch } = this.props;

    this.setState({userCanAccess: userStatus().modules})

    await dispatch(domainActions.getDomainsByToken())
      .then(async res => {
        if ( res.data.data.length === 0 ) return history.push('/domains');
        if (
          res.type === 'VERIFY_DOMAIN_FAILURE'     &&
          history.location.pathname !== "/domains" &&
          res.data.data.length === 0
        ) history.push('/domains');

        let allowed = true;

        if (
          res.data.data[0].status !== "Active" ||
          (
            res.data.data[0].status === "Active" &&
            !res.data.data[0].gero_validate
          )
        ) allowed = false;

        if ( !sessionStorage.getItem('selected_domain') ) {
          await sessionStorage.setItem('selected_domain', JSON.stringify({
            domain: res.data.data[0].name,
            uuid: res.data.data[0].uuid,
            root: res.data.data[0].domain_root,
            gero: res.data.data[0].gero_id,
            status: res.data.data[0].status,
            domain_index: 0,
            allowed
          }));
        }

        let arr = []
        res.data.data.forEach((item, index) => {
          let obj = {
            label: item.name.charAt(0).toUpperCase() + item.name.slice(1),
            value: item.uuid,
            active: item.active,
            validated: item.gero_validate,
            domain_index: index,
            root: item.domain_root,
            gero: item.gero_id,
            status: item.status,
            allowed
          }

          arr.push(obj);
        });

        let json = JSON.parse(sessionStorage.getItem('selected_domain'));
        this.setState({
          selected: json.domain,
          domain_root: json.root,
          gero_id: json.gero,
          status: json.status,
          domains: arr,
          allowed: json.allowed,
          dataHasBeenLoaded: true
        }, async () => {
          let selectedDomain = await dispatch(domainActions.defineSelectedDomain({
            domain_name: json.domain,
            domain_gero_id: json.gero,
            domain_uuid: json.uuid,
            domain_root: json.root
          }));
          
          this.props.handleLoad({shouldReload: true, domain: [selectedDomain.domain]});
        });
      });
  }

  handleClipboard() {
    let json = JSON.parse(sessionStorage.getItem('selected_domain'));
    
    this.setState({
      clipboardBtn: 'Script copiado!',
      clipboardBtnStatus: true,
      gero_id: json.gero,
      domain_root: json.root,
      status: json.status,
      allowed: json.allowed
    })

    setTimeout(() => {
      this.setState({clipboardBtn: 'Copiar script', clipboardBtnStatus: false})
    }, 2000);
  }

  handleDomainChange(e) {
    const { dispatch } = this.props;
    let allowed = true;
    this.props.handleLoad({shouldReload: false});
    
    if ( e.status !== "Active" || ( !e.validated && e.status === "Active" ) ) allowed = false;

    sessionStorage.setItem('selected_domain', JSON.stringify({domain: e.label, uuid: e.value, domain_index: e.domain_index, root: e.root, gero: e.gero, status: e.status, allowed}));
    this.setState({
      selectedDomain: e.label,
      gero_id: e.gero,
      domain_root: e.root,
      status: e.status,
      allowed
    }, () => {
      dispatch(domainActions.defineSelectedDomain({domain_name: e.label, domain_gero_id: e.gero, domain_uuid: e.value, domain_root: e.root}));
    });
    
    this.props.handleLoad({shouldReload: true});

    if ( e.status === "Inactive" || !e.allowed ) return history.push('/domains');
    return history.push(`${history.location.pathname}?domain=${e.value}`);
  }

  handleModalDisplay(e) {
    if ( e ) {
      return this.setState({shouldShowModal: e.target.getAttribute('data-modal-display')});
    }
    return this.setState({shouldShowModal: false});
  }

  handlePageChange(e) {
    if ( !sessionStorage.getItem('selected_domain') ) return;

    let path = e.target.getAttribute('data-target');
    let domain = JSON.parse(sessionStorage.getItem('selected_domain')).uuid;
    
    if ( this.state.lastClicked === path ) return;

    this.setState({lastClicked: path});
    return history.push(`${path}?domain=${domain}`);
  }

  handleSidebarOpening(e) {
    e.target.classList.toggle('active');
    this.sidebar.current.classList.toggle('active');
    this.sidebarWrapper.current.classList.toggle('active');
  }

  async handleUserLogout() {
    const { dispatch } = this.props;

    this.setState({domains: []});

    sessionStorage.removeItem('selected_domain');
    sessionStorage.removeItem('cellit_domains');
    sessionStorage.removeItem('cellit_userdata');

    await dispatch(alertActions.resetStore());

    history.push('/signin');
  }

  render() {
    const { userCanAccess } = this.state;

    return(
      <>
        <div className="sidebar-wrapper" ref={this.sidebarWrapper}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a href="#" className="sidebar-toggle" onClick={this.handleSidebarOpening}>
            <svg className="ham ham-rotate" viewBox="0 0 100 100" width="40">
              <path className="line top" d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20" />
              <path className="line middle" d="m 70,50 h -40" />
              <path className="line bottom" d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20" />
            </svg>
          </a>

          <aside className="sidebar sidebar-fixed" ref={this.sidebar}>
            <div className="sidebar-items-group">
              <div className="logo">
                <img src={CellLogo} alt="Cell logo"/>
              </div>
            </div>

            {
              this.state.domains.length === 0 ?
                null
              : <div className="sidebar-items-group sidebar-items-group-select">
                <form>
                  <span className="select-title">Domínio selecionado</span>
                  {
                    this.state.domains.length !== 0 ?
                      <Select
                        defaultValue={this.state.domains[JSON.parse(sessionStorage.getItem('selected_domain')).domain_index]}
                        options={this.state.domains}
                        onChange={this.handleDomainChange}
                        placeholder=""
                        className="custom-form-control"
                        formatOptionLabel={optionRenderer}
                      />
                    : null
                  }
                </form>

                <button
                  className={`btn-clipboard ${this.state.clipboardBtnStatus ? 'disabled' : ''}`}
                  data-modal-display={true} onClick={this.handleModalDisplay}
                >
                  <i className="linearicons-copy"></i>
                  <span>Copiar script</span>
                </button>

                <hr/>
              </div>
            }

            {
              this.state.domains.length === 0 ?
                null
              : <div className="sidebar-items-group">
                  <ul className="sidebar-items">
                        <Item label="Analytics" path="/" icon="linearicons-chart-bars" e={this.handlePageChange} className={this.state.allowed ? "" : "disabled"} />
                      
                        <Item label="Momentums" path='/v2/momentums' icon="linearicons-site-map" e={this.handlePageChange} className={this.state.allowed ? "" : "disabled"} />
                      
                        <Item label="Campanhas" path="/v2/campaigns" icon="linearicons-bullhorn" e={this.handlePageChange} className={(this.state.allowed ? "" : "disabled")} />

                        <Item label="GCD" path="/dcm" icon="linearicons-code" e={this.handlePageChange} className={(this.state.allowed ? "" : "disabled")} />
                  </ul>
                </div>
            }

            <div className="sidebar-items-group">
              <hr/>
              <p className="sidebar-items-group-description">Administração</p>

              <ul className="sidebar-items">
                    <Item label="Domínios" path="/domains" icon="linearicons-flag3" e={this.handlePageChange} />

                {
                  this.state.domains.length === 0 ?
                    null
                  : <>
                        <Item label="Mídias" path="/media" icon="linearicons-media" e={this.handlePageChange} className={this.state.allowed ? "" : "disabled"} />
                        <Item label="Canais" path="/channels" icon="linearicons-alarm-ringing" e={this.handlePageChange} className={this.state.allowed ? "" : "disabled"} />
                  </>
                }
              </ul>
            </div>

            <div className="sidebar-items-group">
              <hr/>

              <ul className="sidebar-items sidebar-items-logout">
                <Item label="Sair" path="/signin" icon="linearicons-lock" e={this.handleUserLogout}/>
              </ul>
            </div>
          </aside>
        </div>

        <Modal
          className="modal modal-sidebar-script"
          size="lg"
          centered
          show={(this.state.shouldShowModal === "true") ? true : false}
          onHide={this.handleModalDisplay}
        >
          <Modal.Body>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className="close-modal float-right" onClick={this.handleModalDisplay}>
              <i className="linearicons-cross"></i>
            </a>

            <div className="title-wrapper">
              <div className="title-group">
                <p>Domínio</p>
                <h2>{this.state.domain_root}</h2>
              </div>
              <div className="title-group">
                <p>ID de acompanhamento</p>
                <h2>{this.state.gero_id}</h2>
              </div>
            </div>

            <div className="description-wrapper">
              <p className="description-title">Tag de implementação (Gero.js)</p>

              <div className="content">
                <p>Este é seu código de acompanhamento e coleta de dados chamado Gero.js. Copie e cole o código abaixo em todas as páginas de seu domínio na qual quer coletar os dados dos visitantes. O script deve ser colado antes da tag &lt;/body&gt; em qualquer página.</p>

                <pre>
                  <code>
                    <span className="vsgr">{`<`}</span><span className="vsb">script</span><span className="vsgr">{`>`}</span><br />
                    {`  `}<span className="vsb">var</span> <span className="vslb">gls</span> <span className="vsw">=</span> <span className="vslb">document</span>.<span className="vsly">createElement</span>(<span className="vso">"script"</span>);<br />
                    {`  `}<span className="vslb">gls</span>.<span className="vslb">src</span> = <span className="vso">{`"https://personidkbr.com/static/files/gero_loader.min.js"`}</span>;<br />
                    {`  `}<span className="vslb">gls</span>.<span className="vsly">onload</span> = <span className="vsb">function</span> () {`{`} <br />
                    {`    `}<span className="vslb">GeroLoader</span>.<span className="vsly">init</span>{`({`}<br />
                    {`      `}<span className="vslb">domain:</span> <span className="vso">{`".${this.state.domain_root}"`}</span>,<br />
                    {`      `}<span className="vslb">gero_id:</span> <span className="vso">{`"${this.state.gero_id}"`}</span><br />
                    {`    `}{`});`}<br />
                    {`  `}{`}`}<br />
                    {`  `}<span className="vslb">document</span>.<span className="vslb">head</span>.<span className="vsly">appendChild</span>(<span className="vslb">gls</span>)<br />
                    <span className="vsgr">{`</`}</span><span className="vsb">script</span><span className="vsgr">{`>`}</span><br />
                  </code>
                </pre>
              </div>
            </div>

            <div className="description-wrapper">
              <p className="description-title">Inserção do script pelo GTM ( Google Tag Manager ).</p>

              <div className="content">
                <ol>
                  <li>Acesse a conta específica onde está presente o GA ativo.</li>
                  <li>Clique em ADICIONAR UMA NOVA TAG na tela inicial.</li>
                  <li>Na aba seguinte, selecione o tipo de tag para HTML Personalizado.</li>
                  <li>Selecionada a opção, cole o seu Gero Script no campo de texto.</li>
                  <li>Salve e feche as abas. Nesse momento, o GTM está sendo o responsável por inserir o Gero Script em todas as suas páginas onde o GTM está presente. Para verificar demais configurações necessárias para o seu Gero Script, veja o item Gero Script {'>'} Customização.</li>
                </ol>
              </div>
            </div>

            <div className="description-wrapper">
              <p className="description-title">A inserção do Service Worker (SW).</p>
              <div className="content">
                <p>Além dos scripts, precisa ser inserido o SW no domain. Com esse SW nós coletamos os opt-in do usuário que poderá receber Webpush.</p>
                <p>O SW deverá estar inserido no ROOT do domain, ter nome cn_sw.min.js, e estar disponível como arquivo estático público.</p>
                <p>O conteúdo do cn_sw.min.js deve ser esse:</p>
                <pre>
                  <code>
                    <span className="vslb">importScripts</span>( <span className="vso">"https://personidkbr.com/static/files/sw.min.js"</span> )
                  </code>
                </pre>
                <p>E a URL deve ficar algo como: https://{this.state.domain_root}/cn_sw.min.js</p>
              </div>
            </div>

            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className="btn btn-blue float-right"
              onClick={this.handleModalDisplay}>
              OK
            </a>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

class Item extends Component {
  render() {
    return (
      <li className={`item ${(history.location.pathname === this.props.path) ? 'active' : ''} ${this.props.className}`}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="#" onClick={this.props.e} data-target={this.props.path}>
          <i className={this.props.icon}></i>
          <span className="description">{this.props.label}</span>
          <span className="tag">NOVO!</span>
        </a>
      </li>
    )
  }
}

function mapStateToProps(state) {
  return {
    domains: state.listDomainsReducer,
    selectedDomain: state.changeDomainReducer
  };
}

const ConnectedSidebarComponent = connect(mapStateToProps)(SidebarComponent);
export { ConnectedSidebarComponent as Sidebar };